import { Component, Input, OnInit } from '@angular/core';
import { CellData, CellUtil, ComponentData } from '@ddt-web/data-service';
import { OtherIdentifiers } from '@ddt-web/domain';
import * as find from 'lodash/find';
import * as get from 'lodash/get';

@Component({
	selector: 'pi-unsupported-securities',
	templateUrl: './unsupported-securities.component.html',
	styleUrls: ['./unsupported-securities.component.scss']
})
export class UnsupportedSecuritiesComponent implements OnInit {
	@Input() public data: ComponentData;
	@Input() public singleErrorView: boolean;

	public unsupportedSecurities: string[] = [];

	public ngOnInit(): void {
		this.unsupportedSecurities = this.getUnsupportedSecurities();
	}

	private getUnsupportedSecurities(): string[] {
		const portfolioSecuritiesTab = this.data.getTabById('portfolio.securities');
		const cells: CellData[][] = get(portfolioSecuritiesTab, 'tableData[0].cells', []);

		return cells
			.filter(cellDataArray => {
				const positionTypeCellData = CellUtil.getById(cellDataArray, 'positionType');
				const isInvalidPositionType = get(positionTypeCellData, 'formattedValue') === 'INVALID';

				return isInvalidPositionType;
			})
			.filter(cellDataArray => {
				const originPlatformCellData = CellUtil.getById(cellDataArray, 'originPlatform');
				const originPlatform = get(originPlatformCellData, 'formattedValue');
				const isSecurity = get(originPlatform, 'type') === 'SECURITY';

				return isSecurity;
			})
			.map(cellData => {
				const otherIdentifierCellData = CellUtil.getById(cellData, 'otherIdentifiers');
				const otherIdentifiers: OtherIdentifiers[] = get(otherIdentifierCellData, 'rawValue');

				const tickerIdentifier = find(otherIdentifiers, { customIdentifierType: 'ORIGIN_TICKER' }) || find(otherIdentifiers, { identifierType: 'TICKER' });
				const ticker = get(tickerIdentifier, 'identifier', '');

				return ticker;
			});

	}

}
